import './Header.css'
import InteractionManager from './InteractionManager'
import logo from '../img/plane-icon.svg';
import { counter } from '../visualization/twitter-app';
import React, { useEffect, useContext, useState } from 'react';
import AppContext from './AppContext';
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faLongArrowAltUp, faLongArrowAltDown, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const Header = () => {

    const [twCounter, setTwCounter] = useState({ counter: null, comparison: null });

    const dataState = useContext(AppContext);

    useEffect(() => {
        counter()
            .element('tweets-counter')
            .on('execute:stop', response => {
                if (response.data.length) {
                    const comparison = response.data[0].current.metrics && response.data[0].current.metrics.change_previous_week ?
                        response.data[0].current.metrics.change_previous_week.count : null;
                    const twc = {
                        counter: response.data[0].current.count,
                        comparison: comparison ? comparison : 'no data'
                    }
                    setTwCounter(twc);
                }
            })
            .execute()
            .catch(() => {
                console.log(`There was an error with widget tweets-counter`)
            });
    }, [])

    const hasComparison = twCounter.comparison !== 'no data';

    return (
        <div className="d-flex flex-row flex-wrap">
            <div className="col-12 col-md-4 col-xl-3 text-center text-md-start ps-md-3 my-auto">
                <img src={logo} alt="Logo" className="header-image" />
                <p className="col-12 mb-0 header-title"> US Airlines Customer Experience</p>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-xl-6 text-center text-md-start my-auto ps-md-2">
                {dataState.esError && <a className="ES-error">Error: No Living connections. Contact the site administrator</a>}
                {!dataState.esError && <InteractionManager />}
            </div>

            <div className="col-12 col-sm-6 col-md-4 col-xl-3 py-2 py-md-0 my-auto text-start">
                {dataState.esError && <a className="ES-error"></a>}
                <div id="tweets-counter"></div>
                {!dataState.esError && <div id="tweets-counter-ui" className="mx-auto me-md-1">
                    <div className={hasComparison ? 'tc-counter' : 'tc-counter-single'}>
                        {/* <i class="fab fa-twitter"></i> */}
                        {Intl.NumberFormat('en-US').format(twCounter.counter)} <FontAwesomeIcon icon={faTwitter} />
                    </div>
                    {hasComparison && <div className='tc-comparison'>
                        <span className='pe-2'>
                            Change previous week:

                        </span>
                        {twCounter.comparison > 0 && <FontAwesomeIcon className="tc-comparison-green" icon={faLongArrowAltUp} />}
                        {twCounter.comparison < 0 && <FontAwesomeIcon className="tc-comparison-red" icon={faLongArrowAltDown} />}
                        &nbsp; {typeof (twCounter.comparison) === 'string' || !twCounter.comparison ? twCounter.comparison :
                            Math.abs(twCounter.comparison).toFixed(2) + "%"}
                    </div>}
                </div>}
            </div>
        </div>
    );
}

export default Header;